<template>
  <div>
    <div v-if="isEdit">
      <contact-edit :editContact="editContact" @onConfirm="handleConfirmAddContact"></contact-edit>
    </div>
    <div v-else>
      <group class="contact-list">
        <div class="contact-list__item" @click="handleSelect(item.id)" v-for="(item, index) in contactList" :key="item.id">
          <img v-if="isSelected(item.id, index)" class="check-icon" src="../../../stylesheets/images/selected.png" alt="selected">
          <div v-else class="check-icon check-icon--uncheck"></div>
          <div class="contact-list__msg">{{ `${item.contact_name} | ${item.contact_number}` }}</div>
          <div class="contact-list__operate">
            <img class="operate-icon" src="../../../stylesheets/images/edit.png" alt="edit" @click="handelEdit($event, item.id)">
            <img class="operate-icon" src="../../../stylesheets/images/delete.png" alt="delete" @click="handleDelete($event, item.id)">
          </div>
        </div>
      </group>
      <button class="add-contact" @click="handleAdd">添加联系人</button>
      <confirm title="确认删除" cancelText="取消" confirmText="确定" v-model="showConfirm" @on-cancel="onCancel" @on-confirm="onConfirm(delContact.id)">
        <p class="confirm-text">{{ `确定删除${delContact.contact_name}/${delContact.contact_number}` }}</p>
      </confirm>
      <x-alert v-model="showAlert" button-text="知道了" title="提示">
        <p v-if="alertType === 'del'" class="alert-text">待开拍车辆已选择当前联系人，暂不支持删除。需车辆开拍后才可删除。</p>
        <p v-else class="alert-text">待开拍车辆已选择当前联系人，暂不支持修改。需车辆开拍后才可修改。</p>
      </x-alert>
    </div>
  </div>
</template>

<script>
import {
  Group,
  Confirm,
  XAlert
} from '@lx-frontend/cvux'
import ContactEdit from './ContactEdit'

export default {
  components: {
    Group,
    Confirm,
    XAlert,
    ContactEdit
  },
  props: {
    contactList: {
      type: Array,
      default() {
        return []
      }
    },
    selectId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      documentTitleCache: '',
      editContact: {},
      delContact: {},
      showConfirm: false,
      showAlert: false,
      alertType: 'del',
      isEdit: false
    }
  },
  methods: {
    isSelected(id, index) {
      return this.selectId === id || (!this.contactList.some((item) => {
        return item.id === this.selectId
      }) && !index)
    },
    handleSelect(id) {
      this.$emit('update:selectId', id)
      this.$emit('onSelect')
    },
    async handelEdit(e, id) {
      e.stopPropagation()
      if (await this.isOccypy(id)) {
        this.alertType = 'edit'
        this.showAlert = true
      } else {
        this.documentTitleCache = document.title
        document.title = '编辑联系人'
        this.editContact = this.contactList.find((item) => {
          return item.id === id
        })
        this.isEdit = true
      }
    },
    async handleDelete(e, id) {
      e.stopPropagation()
      if (await this.isOccypy(id)) {
        this.alertType = 'del'
        this.showAlert = true
      } else {
        this.delContact = this.contactList.find((item) => {
          return item.id === id
        })
        this.showConfirm = true
      }
    },
    handleAdd() {
      this.editContact = {}
      this.isEdit = true
      this.documentTitleCache = document.title
      document.title = '添加联系人'
    },
    handleConfirmAddContact(id) {
      document.title = this.documentTitleCache
      this.updateContactList()
      this.isEdit = false
    },
    onConfirm(id) {
      this.$rest.auction.delContact(null, id)
        .then((res) => {
          if (res.code === 0) {
            this.updateContactList()
          } else {
            this.showToast(res.message)
          }
        })
    },
    async isOccypy(id) {
      const res = await this.$rest.auction.occupyContact(null, id)
      return res.code
    },
    updateContactList() {
      this.$rest.auction.getContactList()
        .then((res) => {
          if (res.code === 0) {
            const contactList = res.data.contacts
            this.$emit('update:contactList', contactList)
          } else {
            this.showToast(res.message)
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../stylesheets/base/fn.less';
.contact-list__item {
  width: 100%;
  height: 100/@w2;
  background-color: #ffffff;
  box-shadow: 0px 0.5px 0px 0px #d9d9d9;
  padding: 0 36/@w2 0 30/@w2;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.contact-list__msg {
  font-size: 30/@w2;
  color: #333333;
  margin: 0 30/@w2;
  flex-grow: 1;
}
.contact-list__operate {
  height: 100%;
  display: flex;
  align-items: center;
}
.check-icon {
  width: 28/@w2;
  height: 28/@w2;
  &--uncheck {
    border-radius: 14/@w2;
    border: 1px solid #e0e0e0;
    box-sizing: border-box;
  }
}
.operate-icon {
  width: 31/@w2;
  height: 30/@w2;
  padding: 10/@w2;
  box-sizing: content-box;
  margin-left: 19/@w2;
}
.add-contact {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 61/@w2 0;
  width: 600/@w2;
  height: 90/@w2;
  border-radius: 9/@w2;
  border: solid 1px #3a5999;
  background: transparent;
  font-size: 30/@w2;
  color: #3a5999;
}
.confirm-text {
  text-align: center;
}
</style>
